import { render } from "./photo-10.vue?vue&type=template&id=620bcf2a&scoped=true"
import script from "./photo-10.vue?vue&type=script&lang=js"
export * from "./photo-10.vue?vue&type=script&lang=js"

import "./photo-10.vue?vue&type=style&index=0&id=620bcf2a&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620bcf2a"]])

export default __exports__